<script lang="ts">
export default {
  name: 'UILayer',
};
</script>

<script setup lang="ts">
import { computed, inject } from 'vue';
import { TowerInfo } from './AccountTowerVisualizer';
import { TowerCardData, TowerType } from '@/views/tower_dashboard/types/tower-dashboard';
import ExportList from '@/views/tower_visualizer/ExportList.vue';
import ExportButton from '@/views/tower_visualizer/ExportButton.vue';
import { ChevronsLeft } from 'lucide-vue-next';
import Zoom from '@/views/tower/v2/Zoom.vue';

const towerInfo = inject<TowerInfo>('towerInfo');

const emit = defineEmits<{
  goBack: [];
}>();

const activeTower = computed(() => {
  return towerInfo?.selectedTower.value;
});

function getTowerName(towerCard: TowerCardData): string {
  if (towerCard.towerTypeId === TowerType.MultiTower) {
    return 'Multi-Tower';
  } else if (towerCard.program) {
    return towerCard.program.name;
  } else if (towerCard.towerName) {
    return towerCard.towerName;
  }

  return '';
}
</script>

<template>
  <div
    class="tw:absolute tw:grid tw:justify-items-start tw:w-full tw:h-full tw:pointer-events-none tw:z-20 tw:opacity-95"
  >
    <div class="tw:pt-1 tw:flex tw:row-start-1 tw:col-start-1">
      <div
        @click="emit('goBack')"
        class="tw:h-fit tw:bg-base-200 tw:border tw:border-solid tw:border-gray-300 tw:flex tw:items-center tw:justify-center tw:cursor-pointer tw:pointer-events-auto tw:border-box tw:rounded-md tw:shadow-lg tw:hover:bg-gray-300 tw:transition-all tw:px-1 tw:py-1 tw:m-2"
      >
        <ChevronsLeft class="tw:scale-75" />
        <span class="tw:mr-2">Back</span>
      </div>
      <div v-if="activeTower" class="tw:flex tw:flex-col tw:pl-2 tw:h-fit tw:items-center">
        <span v-if="activeTower.versionLabel" class="tw:font-bold">{{ activeTower.versionLabel }}</span>
        <span class="tw:text-xs">{{ getTowerName(activeTower) }}</span>
      </div>
    </div>
    <Zoom 
      class="tw:w-40 tw:pr-2 tw:col-start-1"
      bg-color="base-200"
      border-color="gray-300"
    />
    <div class="tw:col-start-2 tw:row-start-2 tw:flex tw:flex-col tw:w-full tw:h-full tw:justify-end">
      <ExportList class="tw:w-40 tw:pr-2 tw:self-end" />
      <ExportButton />
    </div>
  </div>
</template>
